import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import { navigate } from "vike/client/router"
import Typography from "aldoo-ra/Typography"
import MenuGroup from "aldoo-ra/MenuGroup"
import Value from "aldoo-ra/Value"

const SquareBanner = () => {
  const [platform, setPlatform] = Value("detected_platform")

  return (
    <CMSRender
      contentType="BlogBanner"
      match={{ "content.id": "square" }}
      renderItem={(banner) => {
        const handleClick = () => {
          const target = banner.target?.[0]?.link?.[0]?.url
          if (!target) return
          //if the link is relative, navigate to it, otherwise open it in a new tab
          if (target.startsWith("/")) return navigate(target)
          //open the link in a new tab
          window.open(target)
        }

        return (
          <div className="relative bg-gradient_pwu_collaborate rounded-[50px] overflow-hidden">
            {/* Background Image - Set to cover the entire container */}
            <img
              src={banner.background_image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Content container with higher z-index */}
            <div className="relative flex flex-col items-center gap-6 text-center px-[22px] py-[32px] z-10">
              {/* App Icon */}
              <div className="md:w-[90px] lg:w-[80px] h-auto aspect-1/1">
                <img
                  src={banner.image}
                  alt="Oxford Dictionary"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Title */}
              <Typography 
                variant="h3"
                className="w-full max-w-[380px]"
              >
                {banner.title}
              </Typography>

              <MenuGroup
                name="Header Download"
                renderAs="hlist"
                styleOverrides={{
                  menu_item: "my-0",
                }}
                itemWidth="150px"
                itemsAsLinks={false}
                menuItemRender={(item) => {
                  const url =
                    (item?.link[0]?.parameters &&
                      item?.link[0]?.parameters[platform]) ||
                    item?.link[0]?.url
                  return (
                    <Button variant="primary_xl">
                      <a href={url} target="_blank">
                        {item?.label}
                      </a>
                    </Button>
                  )
                }}
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default SquareBanner
